export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";